

const getType =(value) =>{
    if(Array.isArray(value)){
       return "Array"
    }else if(value instanceof Map){
       return"Map"
    }else{
       return "String"
    }
}





export { getType };